// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"5f522827","239":"c81d1a28","453":"73f810e2","455":"07afa09d","641":"5f979425","977":"9a56fd24"}[chunkId] + ".chunk.js";
};